import React from "react";
import { useMap } from "react-map-gl/mapbox-legacy";
import { MapTool } from "./MapTool";

export const ZoomControl = () => {
  const { current: map } = useMap();

  const handleZoomIn = () => {
    map?.zoomIn();
  };

  const handleZoomOut = () => {
    map?.zoomOut();
  };

  return (
    <MapTool>
      <div className="mapboxgl-ctrl mapboxgl-ctrl-group">
        <button
          className="mapboxgl-ctrl-zoom-in"
          type="button"
          title="Zoom in"
          aria-label="Zoom in"
          onClick={handleZoomIn}
        >
          <span className="mapboxgl-ctrl-icon" aria-hidden="true" />
        </button>
        <button
          className="mapboxgl-ctrl-zoom-out"
          type="button"
          title="Zoom out"
          aria-label="Zoom out"
          onClick={handleZoomOut}
        >
          <span className="mapboxgl-ctrl-icon" aria-hidden="true" />
        </button>
      </div>
    </MapTool>
  );
};
